import React from 'react';
import PropTypes from 'prop-types';

import SearchResult from '../SearchResult';


const cleanUrl = (type, url) => {
  if (!url) return url;

  if (type === 'image') {
    return url.replace('s3.amazonaws.com/developertool/', 'imgtravpromobile.imgix.net/');
  }
  return url;
};

/**
 * An object passed to algolia Hits as a hitComponent to transform data to a searchResult based on the type of the algolia Hit.
 *
 * @param { object } hit - An algolia Hit object. Returned from algolia search.
 * @param { string } type - The type of search result. Used to determine how to transform the hit.
 * @param {Function} onSelect - A function to call when the search result is selected (primarily to close the modal)
 *
 * @returns {JSX.Element} A searchResult component.
 */
const Hit = ({ hit, type, onSelect }) => {
  let resultTitle = '';
  let resultIcon = null;
  let resultBackground = '';
  let resultUrl = '';
  let resultType = '';

  if (type === 'apps') {
    const {
      name: hitTitle, id: hitId, icon: hitIcon, splash_screen: hitBackground,
    } = hit;

    resultTitle = hitTitle;
    resultIcon = hitIcon;
    resultBackground = cleanUrl('image', hitBackground);
    resultUrl = `/info/${hitId}`;
  }

  if (type === 'pages') {
    const {
      title: hitTitle, image: hitBackground, chapter_id: hitChapterId, number: hitPageNumber,
    } = hit;
    resultTitle = hitTitle;
    resultBackground = cleanUrl('image', hitBackground);
    resultUrl = `/main/retain/chapter/${hitChapterId}/${hitPageNumber - 1}`;
  }

  if (type === 'sales_companion_items') {
    const {
      title: hitTitle, image: hitBackground, url: hitUrl, type: hitType,
    } = hit;
    resultTitle = hitTitle;
    resultBackground = cleanUrl('image', hitBackground);
    resultUrl = hitUrl;
    resultType = hitType;
  }

  return (
    <SearchResult
      title={resultTitle}
      icon={resultIcon}
      backgroundImage={resultBackground}
      url={resultUrl}
      onSelect={onSelect}
      type={type}
      hitType={resultType}
    />
  );
};

Hit.propTypes = {
  hit: PropTypes.oneOfType([
    // Hit for app search
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      icon: PropTypes.string.isRequired,
      splash_screen: PropTypes.string.isRequired,
    }),
    // Hit for pages search
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      chapter_id: PropTypes.number.isRequired,
      number: PropTypes.number.isRequired,
    }),
    // Hit for sales companion items search
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  type: PropTypes.oneOf(['apps', 'pages', 'sales_companion_items']).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default Hit;
